import { createAction, createSlice } from '@reduxjs/toolkit';

export const loadComplaintStatusAndPriorityRequest = createAction('complaintStatusAndPriority/loadComplaintStatusAndPriorityRequest');

const initialState = {
    statusOptions: {},
    priorityOptions: {},
    loading: false,
    error: null,
};

const complaintStatusAndPrioritySlice = createSlice({
    name: 'complaintStatusAndPriority',
    initialState,
    reducers: {
        fetchComplaintStatusAndPriorityStart(state) {
            state.loading = true;
            state.error = null;
        },
        fetchComplaintStatusAndPrioritySuccess(state, action) {
            state.loading = false;
            state.error = null;
            const { statusOptions, priorityOptions } = action.payload;
            state.statusOptions = statusOptions ?? {};
            state.priorityOptions = priorityOptions ?? {};
        },
        fetchComplaintStatusAndPriorityFailure(state, action) {
            state.loading = false;
            state.error = action.payload;
        }
    },
});

export const { fetchComplaintStatusAndPriorityStart, fetchComplaintStatusAndPrioritySuccess, fetchComplaintStatusAndPriorityFailure } = complaintStatusAndPrioritySlice.actions;

export default complaintStatusAndPrioritySlice.reducer;